module.exports = __webpack_public_path__ + "static/media/yellow_swoop.9d4faba9.png";